module.exports = __webpack_public_path__ + "static/media/Silver_Badge.3271aabb.zip";